import { useSearchParams } from 'react-router-dom'

import { getDateFormatted } from '@/common/components/FiltersSection/helpers'
import { timeRangeValues } from '@/common/components/TimeRangeSelect/constants'
import {
  getPeriodCap,
  getPeriodLimits,
  getPeriodParams,
  getValidPeriodFromSearch,
} from '@/metrics/pages/PerformanceInsightsPage/helpers'
import usePerformanceInsightsAvailability from '@/metrics/pages/PerformanceInsightsPage/hooks/usePerformanceInsightsAvailability/usePerformanceInsightsAvailability'

const usePerformanceInsightsPeriod = ({ storeId, isAvailabilityEnabled }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const cap = getPeriodCap(new Date())
  const period = getValidPeriodFromSearch(searchParams, getPeriodLimits(cap))
  const requestedPeriodParams = getPeriodParams(period, cap)

  const { availability, fetchingAvailability, availabilityError } = usePerformanceInsightsAvailability({
    storeId,
    startDate: requestedPeriodParams.start_date,
    endDate: requestedPeriodParams.end_date,
    enabled: isAvailabilityEnabled,
  })

  const dataAvailableFrom = availability?.data_available_from
  const { minDate, maxDate } = getPeriodLimits(cap, dataAvailableFrom)

  const handleTimeRangeChange = timeRange => {
    setSearchParams(currentParams => {
      const nextParams = new URLSearchParams(currentParams)

      nextParams.set('timeRange', timeRange)
      nextParams.delete('startDate')
      nextParams.delete('endDate')

      return nextParams
    })
  }

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSearchParams(currentParams => {
      const nextParams = new URLSearchParams(currentParams)

      nextParams.set('timeRange', timeRangeValues.custom)
      nextParams.set('startDate', getDateFormatted(startDate))
      nextParams.set('endDate', getDateFormatted(endDate))

      return nextParams
    })
  }

  return {
    timeRange: period.timeRange,
    startDate: period.startDate,
    endDate: period.endDate,
    minDate,
    maxDate,
    periodParams: getPeriodParams(period, cap, dataAvailableFrom),
    availability,
    fetchingAvailability,
    availabilityError,
    handleTimeRangeChange,
    handleDateRangeChange,
  }
}

export default usePerformanceInsightsPeriod
